module.exports = __webpack_public_path__ + "img/mandala-wide.372a68d2.jpg";